import { useEffect, useRef } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import Image from "./Images/NoEntry.webp";
import Image2 from "./Images/entry.jpg";

export default function ThreeCanvas() {
  const mountRef = useRef();

  useEffect(() => {
    const width = mountRef.current.clientWidth;
    const height = mountRef.current.clientHeight;

    const scene = new THREE.Scene();
    scene.background = new THREE.Color("black");
    const camera = new THREE.PerspectiveCamera(50, width / height, 0.1, 1000);
    camera.position.set(0, 0, 7);

    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(width, height);
    mountRef.current.appendChild(renderer.domElement);

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);

    const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
    directionalLight.position.set(5, 5, 5);
    scene.add(directionalLight);
    const frontLight = new THREE.DirectionalLight(0xffffff, 1);
    frontLight.position.set(5, 0, 5); // In front of the object
    scene.add(frontLight);
    const BackLight = new THREE.DirectionalLight(0xffffff, 1.5);
    BackLight.position.set(5, 0, -5); // In front of the object
    scene.add(BackLight);
    const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 0.5); // skyColor, groundColor, intensity
    hemiLight.position.set(0, 20, 0);
    scene.add(hemiLight);

    // const lightHelper = new THREE.DirectionalLightHelper(frontLight, 1);
    // scene.add(lightHelper);

    // Load textures
    const loader = new THREE.TextureLoader();
    const frontTexture = loader.load(Image2); // Replace with your path
    const backTexture = loader.load(Image); // Replace with your path

    const defaultMaterial = new THREE.MeshStandardMaterial({
      color: "#cccccc",
    });

    // Create materials for each face
    const materials = [
      defaultMaterial, // Right
      defaultMaterial, // Left
      defaultMaterial, // Top
      defaultMaterial, // Bottom
      new THREE.MeshStandardMaterial({ map: frontTexture }), // Front (+Z)
      new THREE.MeshStandardMaterial({ map: backTexture }), // Back (−Z)
    ];

    const geometry = new THREE.BoxGeometry(5, 3, 0.4); // x, y, z
    const cube = new THREE.Mesh(geometry, materials);
    scene.add(cube);

    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;

    const animate = () => {
      requestAnimationFrame(animate);
      controls.update();
      renderer.render(scene, camera);
    };
    animate();

    return () => {
      renderer.dispose();
      mountRef.current.removeChild(renderer.domElement);
    };
  }, []);

  return (
    <div
      ref={mountRef}
      style={{ width: "100%", height: "90%", backgroundColor: "gray" }}
    />
  );
}
